import RouteVO from "@routes/route";
import React from "react";

const pages: RouteVO[] = [
  {
    path: "/index",
    title: "疫情",
    uniqueKey: "Index",
    component: React.lazy(() => import("@pages/epidemicSituation/EpidemicSituation")),
    exact: true,
    routes: []
  },
  {
    path: "/advertisement",
    title: "广告",
    uniqueKey: "advertisement",
    component: React.lazy(() => import("@pages/advertisement/Index")),
    exact: true,
    routes: []
  },
  {
    path: "/home",
    title: "首页",
    uniqueKey: "Home1",
    component: React.lazy(() => import("@pages/index/Index")),
    exact: true,
    routes: []
  },
  {
    path: "/adviser",
    title: "开店顾问",
    uniqueKey: "Adviser",
    component: React.lazy(() => import("@/pages/adviser/Adviser")),
    exact: true,
    routes: []
  },
  {
    path: "/community-search",
    title: "点点社区",
    uniqueKey: "CommunitySearch",
    component: React.lazy(() => import("@/pages/communitySearch/CommunitySearch")),
    exact: true,
    routes: []
  },
  {
    path: "/covi-report",
    title: "街道",
    uniqueKey: "coviReport",
    component: React.lazy(() => import("@/pages/report-covi/index")),
    exact: true,
    routes: []
  },
  {
    path: "/big-shot",
    title: "点点大咖",
    uniqueKey: "BigShot",
    component: React.lazy(() => import("@/pages/bigShot/BigShot")),
    exact: true,
    routes: []
  },
  {
    path: "/",
    title: "AI体验",
    uniqueKey: "1",
    component: React.lazy(() => import("@/pages/home/Home")),
    exact: true,
    routes: [],
  },
  {
    path: "/community-report",
    title: "社区报告",
    uniqueKey: "CommunityReport",
    component: React.lazy(
      () => import("@pages/communityReport/CommunityReport")
    ),
    exact: true,
    routes: []
  },
  {
    path: "/ai-report",
    title: "AI体验",
    uniqueKey: "AIReport",
    component: React.lazy(() => import("@pages/ai-report/AIReport")),
    exact: true,
    routes: [],
  },
  {
    path: "/cities",
    title: "城市选择",
    uniqueKey: "Cities",
    component: React.lazy(() => import("@pages/cities/Cities")),
    exact: true,
    routes: [],
  },
  {
    path: "/communities",
    title: "社区选择",
    uniqueKey: "Communities",
    component: React.lazy(() => import("@pages/communities/Communities")),
    exact: true,
    routes: [],
  },
  {
    path: "/brands",
    title: "查询品牌",
    uniqueKey: "Brands",
    component: React.lazy(() => import("@pages/brands/Brands")),
    exact: true,
    routes: [],
  },
  {
    path: "/epidemic-situation",
    title: "疫情地图",
    uniqueKey: "EpidemicSituation",
    component: React.lazy(
      () => import("@pages/epidemicSituation/EpidemicSituation")
    ),
    exact: true,
    routes: [],
  },
  {
    path: "/covi-monit",
    title: "核酸采样点",
    uniqueKey: "CoviMonit",
    component: React.lazy(
      () => import("@pages/coviMonit/coviMonit")
    ),
    exact: true,
    routes: [],
  },
  {
    path: "/covi-monit-map",
    title: "核酸采样点查询",
    uniqueKey: "CoviMonitMap",
    component: React.lazy(
      () => import("@pages/covi-monit-map/coviMonitMap")
    ),
    exact: true,
    routes: [],
  },
  {
    path: "/insight",
    title: "区域洞察",
    uniqueKey: "insight",
    component: React.lazy(
      () => import("@pages/insight/index")
    ),
    exact: true,
    routes: [],
  },
  {
    path: "/community",
    title: "点点社区",
    uniqueKey: "community",
    component: React.lazy(
      () => import("@pages/community/index")
    ),
    exact: true,
    routes: [],
  },
  {
    path: "/insight-detail",
    title: "价值评估",
    uniqueKey: "insightDetail",
    component: React.lazy(
      () => import("@pages/insight-detail/index")
    ),
    exact: true,
    routes: [],
  },
];

export default pages;
